import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class CompletedPageActions extends Actions{
    static get target(){
        return 'completedPages'
    }

    static reset(){
        this.set(['sessions'])
    }

    static append(data){
        if(!this.state.completedPages.includes(data)){
            this.set([...this.state.completedPages,data])
        }
    }
}


// WEBPACK FOOTER //
// ./actions/CompletedPageActions.js